export default defineNuxtPlugin(nuxt => {
  const appMetadata = useAppMetadata()

  nuxt.hook("app:manifest:update", meta => {
    if (meta) {
      appMetadata.value = meta
    }
  })
})
